import React, { useEffect } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { Row, Col } from 'react-bootstrap'
import { useSelector } from 'react-redux';
import Loader from '../components/Loader';
import FormContainer from '../components/FormContainer';
import Login from '../components/Login/Login';

function LoginScreen() {
    const location = useLocation()
    const redirect = location.search ? location.search.split('=')[1] : '/'
    const navigate = useNavigate()

    const {
        userReducers: { loading, user }
    } = useSelector((state) => state)

    useEffect(() => {
        if(user){
            navigate('/profile')
        }
    }, [user, navigate])

  return (
    <>
        {loading ? <Loader />:
        <FormContainer>
                
                <Login />

                <Row className='py-3'>
                    <Col>
                        <span className='text-muted'>Don't have an account?</span> &nbsp;
                        <Link to={redirect ? `/register?redirect=${redirect}` : '/register'} className='link text-decoration-none fw-semibold'>
                            Sign up
                        </Link>
                    </Col>
                </Row>
                
            </FormContainer>
            
        }
    </>
  )
}

export default LoginScreen
